import RecoverAccount from './RecoverAccount';

export default RecoverAccount;
